<template>
  <form-wrapper @submit="onSubmit">
    <div slot="box" v-loading="loading">
      <el-form-item label="Title" :error="errors['title']" required>
        <el-input v-model="form['title']" />
      </el-form-item>
      <el-form-item
        label="Alternative text (for readers)"
        :error="errors['alt']"
      >
        <el-input v-model="form['alt']" />
      </el-form-item>
      <div>
        <h2>Image</h2>
        <image-cropper
          v-if="form.file_url && (showAllCrops || onlyShowNormalCrop)"
          v-model="form.normal_crop.file"
          :src="form.file_url"
          :cropTop.sync="form.normal_crop.top"
          :cropLeft.sync="form.normal_crop.left"
          :cropWidth.sync="form.normal_crop.width"
          :cropHeight.sync="form.normal_crop.height"
          header="Default"
          :stencilWidth="1280"
          :stencilHeight="913"
        />
        <image-cropper
          v-if="form.file_url && (showAllCrops || onlyShowShortCrop)"
          v-model="form.short_crop.file"
          :src="form.file_url"
          :cropTop.sync="form.short_crop.top"
          :cropLeft.sync="form.short_crop.left"
          :cropWidth.sync="form.short_crop.width"
          :cropHeight.sync="form.short_crop.height"
          header="Short"
          :stencilWidth="1280"
          :stencilHeight="357"
        />
        <image-cropper
          v-if="form.file_url && (showAllCrops || onlyShowSmallCrop)"
          v-model="form.small_crop.file"
          :src="form.file_url"
          :cropTop.sync="form.small_crop.top"
          :cropLeft.sync="form.small_crop.left"
          :cropWidth.sync="form.small_crop.width"
          :cropHeight.sync="form.small_crop.height"
          header="Small"
          :stencilWidth="100"
          :stencilHeight="100"
          stencilComponent="circle-stencil"
        />
        <p>To change image</p>
        <upload-tab @submit="changeImage" />
      </div>
    </div>
    <form-nav
      :loading="loading"
      slot="navbar"
      @submit="onSubmit"
      :inModal="inModal"
      modalLabel="Edit image"
      :redirectRoute="redirectRoute"
    />
  </form-wrapper>
</template>
<script>
import { Image } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import UploadTab from '@/components/inputs/ImageDialog/UploadTab'
import ImageCropper from './ImageCropper'

export default {
  mixins: [FormMixin],
  props: {
    onlyShowNormalCrop: {
      default: false
    },
    onlyShowShortCrop: {
      default: false
    },
    onlyShowSmallCrop: {
      default: false
    },
    defaultThumbnail: {
      default: false
    }
  },
  components: {
    UploadTab,
    ImageCropper
  },
  data() {
    return {
      redirectRoute: { name: 'Image List' }
    }
  },
  methods: {
    instanceFetchCallback() {
      this.prepareFormCopyToPreventChangesLost()
      if (!this.form.normal_crop) {
        this.form.normal_crop = {}
      }
      if (!this.form.short_crop) {
        this.form.short_crop = {}
      }
      if (!this.form.small_crop) {
        this.form.small_crop = {}
      }
    },
    getPreparedPayload(payload) {
      if (
        payload.hasOwnProperty('normal_crop') &&
        typeof payload.normal_crop.file !== 'object'
      ) {
        delete payload.normal_crop.file
      }
      if (
        payload.hasOwnProperty('short_crop') &&
        typeof payload.short_crop.file !== 'object'
      ) {
        delete payload.short_crop.file
      }
      if (
        payload.hasOwnProperty('small_crop') &&
        typeof payload.small_crop.file !== 'object'
      ) {
        delete payload.small_crop.file
      }
      return payload
    },
    changeImage(image) {
      if (!image) return
      this.$set(this.form, 'file', image)
      for (let key of ['normal_crop', 'short_crop', 'small_crop']) {
        if (!this.form.hasOwnProperty(key)) {
          this.$set(this.form, key, {})
        }
      }
      this.updateImagePreview()
    },
    updateImagePreview() {
      const value = this.form.file
      const fileType = typeof value
      if (fileType === 'object') {
        const reader = new FileReader()
        reader.onload = e => {
          this.$set(this.form, 'file_url', e.target.result)
        }
        reader.readAsDataURL(this.form.file)
      }
    }
  },
  computed: {
    service() {
      return Image
    },
    showAllCrops() {
      return (
        !this.onlyShowShortCrop &&
        !this.onlyShowNormalCrop &&
        !this.onlyShowSmallCrop
      )
    }
  }
}
</script>
